<template>
    
      <form data-vv-scope="ClasseMatiere" @submit.prevent="ClasseMatiere_validate">
      <vx-card  :title="typeMatiere.libelle"  class="mb-2 mt-6">
      <template slot="actions">
        <div class="vx-row">
          <vs-button radius color="#4537ab" type="filled" class="mr-4 mb-2 col-6" > . {{ typeMatiereObject[typeMatiere.id].length }} .</vs-button>
          <vs-button color="primary" type="gradient" icon-pack="feather" class="col-6 mr-4" icon="icon-plus" @click="addMatter()"></vs-button>
        </div>
        </template>
        <div slot="no-body" class="tabs-container px-6 pt-6">
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          </div>
          <!-- {{ input.length }}  -->
        <vs-popup
          class="holamundo"
          :title="$t('In_which_classes_will_you_use_this_type_of_fee')"
          :active.sync="popupActive"
        >

        <vs-list>
          <vs-list-header title="Les matières concernées par ce type de matière" color="primary"></vs-list-header>
          <vs-list-item :title="$t('Select_all')">
            <vs-checkbox slot="avatar" color="success" v-model="allMatiereSelect"></vs-checkbox>

          </vs-list-item>

          <vs-list-item v-for="(matiere, index) in matieres" :key="index" @click="matiere.checkBox = matiere.checkBox ? false : true" :title="matiere.libelle">
            <vs-checkbox slot="avatar" color="success" v-model="matiere.checkBox"></vs-checkbox>

            <vs-chip color="success">
              <b>
                {{ index + 1 }}

              </b>
            </vs-chip>
          </vs-list-item>
        </vs-list>

        <vs-button
          v-if="!matieres.length"
          class="mt-5"
          icon-pack="feather"
          icon="icon-check"
          disabled
        >
          Valider
        </vs-button>
        <vs-button
          v-if="matieres.length"
          class="mt-5"
          icon-pack="feather"
          icon="icon-check"
          @click="validerFonction()"
        >
          Valider
        </vs-button>
      </vs-popup>

        <vx-card>
          <div slot="no-body" class="tabs-container px-6 pt-6">
            

             <table width="100%" v-if="typeMatiereObject[typeMatiere.id].length > 0">
            <thead>
              <tr>
                <!-- <th> {{ $t("class") }} </th> -->
                <th> {{ $t("matter") }} </th>
                <!-- <th> {{ $t("matter_type") }} </th> -->
                <th> {{ $t("coefficient") }} </th>
              </tr>
            </thead>

            <tbody>
              <tr :key="indextr" v-for="(tr, indextr) in typeMatiereObject[typeMatiere.id]">
                <td class="pl-4">
                  <p class="product-name font-medium truncate">{{ tr.libelle }}</p>
                </td>
                <td>
                  <vs-input-number v-model="tr.coef" class="w-full ml-0" :name="'coef' + indextr" v-validate="'required'" />
                  <span class="text-danger">{{ errors.first('ClasseMatiere.coef' + indextr) }}</span>

                </td>
              </tr>
            </tbody>
          </table>

            <!-- <vs-button :disabled="!input.length" class="mt-4" color="success" type="border" icon-pack="feather" icon="icon-save" @click="ClasseMatiere_validate">{{ $t("Submit") }}</vs-button> -->
          </div>
        </vx-card>
          
          <!-- <vs-button class="mt-4 mb-4" color="success" type="border" icon-pack="feather" icon="icon-save" @click="ClasseMatiere_validate">{{ $t("Submit") }}</vs-button> -->
        </div>
      </vx-card>
      </form>
          
</template>

<script>
export default {
  props: {
    matieres:  {
      type: Array,
      default: () => []
    },
    typeMatiere:  {
      type: Object,
      default: () => {}
    },
    typeMatiereObject: {
      type: Object,
      default: () => {}
    },
    isValid: {
      type: Object,
      default: () => {}
    },
    verification: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      popupActive: false,
      allMatiereSelect: false,
      erors: []
    }
  },
  watch: {
    allMatiereSelect (value) {
      const length = this.matieres.length
      for (let i = 0; i < length; i++) {
        this.matieres[i].checkBox = value
      }
    },
    verification () {
      this.ClasseMatiere_validate()
    }
  },
  methods: {

    ClasseMatiere_validate () {
      this.$validator.validateAll('ClasseMatiere').then(result => {
        if (result) {
          this.isValid[this.typeMatiere.id] = true
        } else {
          this.isValid[this.typeMatiere.id] = false
        }
        this.$emit('updateIsValid', this.isValid)
      })
    },

    addMatter () {
      for (let i = 0; i < this.matieres.length; i++) {
        if (this.matieres[i].checkBox) {
          this.matieres.splice(i, 1)
          i--
        }
      }
      this.popupActive = true
      this.matieres.push(...this.typeMatiereObject[this.typeMatiere.id])
    },

    initCoef () {
      for (let i = 0; i < this.typeMatiereObject[this.typeMatiere.id].length; i++) {
        const element = this.typeMatiereObject[this.typeMatiere.id][i]
        if (!element.coef) {
          element.coef = ''
        }      
      }
    },

    validerFonction () {
      const list_matieres = []
      let length = this.matieres.length
      
      for (let i = 0; i < length; i++) {
        if (this.matieres[i].checkBox) {
          list_matieres.push(this.matieres[i])
          this.matieres.splice(i, 1)
          i--
          length--
        }
      }
      this.typeMatiereObject[this.typeMatiere.id] = list_matieres
      this.initCoef()
      this.popupActive = false

    }
  }

}

</script>

<style scoped>

</style>
